import { format } from "date-fns";

export const formatDate = (value: string, param: string): string =>
  format(new Date(value as string), param);

export const formatCurrency = (number: number): string =>
  new Intl.NumberFormat("hu-HU").format(number);
